import React from 'react';
import { Target, Award, Users, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';
import PromoVideo from '../components/PromoVideo';

const About = () => {
  const { t } = useLanguage();
  
  return (
    <div className="dark-container pt-20">
      <SEO title="Chi Siamo - ALLMX" description="Scopri ALLMX: il negozio online per ricambi e accessori motocross premium. Spedizione veloce dall'Italia." url="https://allmx.it/about" />
      <section
        className="hero-section"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1721016955385-00bf62baf5de)',
          minHeight: '60vh'
        }}
      >
        <div className="hero-overlay"></div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-[7.6923%] text-center">
          <h1 className="display-huge mb-6">{t.about.title}</h1>
          <p className="body-large max-w-2xl mx-auto" style={{ color: 'var(--text-secondary)' }}>
            {t.about.subtitle}
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 px-6 lg:px-[7.6923%]">
        <div className="max-w-4xl mx-auto">
          <h2 className="display-medium mb-8 text-center">{t.about.storyTitle}</h2>
          <div className="space-y-6 body-large" style={{ color: 'var(--text-secondary)' }}>
            <p>{t.about.storyP1}</p>
            <p>{t.about.storyP2}</p>
            <p>{t.about.storyP3}</p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 px-6 lg:px-[7.6923%]" style={{ backgroundColor: 'var(--bg-secondary)' }}>
        <div className="max-w-[1400px] mx-auto">
          <h2 className="display-medium text-center mb-16">{t.about.valuesTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <Target size={32} style={{ color: 'var(--brand-primary)' }} />
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-3">{t.about.value1Title}</h3>
                <p className="body-medium">{t.about.value1Desc}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <Award size={32} style={{ color: 'var(--brand-primary)' }} />
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-3">{t.about.value2Title}</h3>
                <p className="body-medium">{t.about.value2Desc}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <Users size={32} style={{ color: 'var(--brand-primary)' }} />
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-3">{t.about.value3Title}</h3>
                <p className="body-medium">{t.about.value3Desc}</p>
              </div>
            </div>

            <div className="flex gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 flex items-center justify-center" style={{ backgroundColor: 'var(--brand-hover)' }}>
                  <MapPin size={32} style={{ color: 'var(--brand-primary)' }} />
                </div>
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-3">{t.about.value4Title}</h3>
                <p className="body-medium">{t.about.value4Desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PromoVideo id="video" />

      {/* Location Section */}
      <section className="py-20 px-6 lg:px-[7.6923%]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="display-medium mb-6">{t.about.locationTitle}</h2>
          <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
            {t.about.locationDesc}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            <div className="dark-card p-6">
              <div className="text-3xl font-bold mb-2" style={{ color: 'var(--brand-primary)' }}>
                1000+
              </div>
              <div className="body-medium">{t.about.stat1}</div>
            </div>
            <div className="dark-card p-6">
              <div className="text-3xl font-bold mb-2" style={{ color: 'var(--brand-primary)' }}>
                500+
              </div>
              <div className="body-medium">{t.about.stat2}</div>
            </div>
            <div className="dark-card p-6">
              <div className="text-3xl font-bold mb-2" style={{ color: 'var(--brand-primary)' }}>
                98%
              </div>
              <div className="body-medium">{t.about.stat3}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
